import * as API from 'common/constant/routes'
import { getJson, postJson } from 'helper/http'
import toSnakeCase from '@deliverance-ai/map-keys-case/to-snake-case'

export const getAllTags = (table) => getJson(API.GET_ALL_TAGS, {}, { table })
export const addTag = (values) => postJson(API.ADD_TAG, {}, { ...values })
export const editTag = (values) => postJson(API.EDIT_TAG, {}, { ...values })
export const deleteTag = (uuid) => postJson(API.DELETE_TAG, {}, { uuid })
export const searchTags = (searchTerm) => getJson(API.SEARCH_TAGS, {}, toSnakeCase({ searchTerm }))
